import { withCurrentParams } from '@shoflo/studio-redux/utils/routeMatch';
import { mapSignedUrlsToSources } from '@shoflo/studio-redux/utils/sources';
import toggleBackgroundHidden from '@shoflo/studio-redux/actions/background/toggleBackgroundHidden';
import {
  BackgroundStyles,
  FILL_FRAME
} from '@shoflo/polymer/constants/LayerPositions';
import { IMAGE_FILE } from '@shoflo/polymer/constants/SourceItems';

import { BROADCAST_TAKE_BACKGROUND_LIVE } from 'actions/Types';

function selectBackground(template) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { program, backgrounds } = getState();

      const action = {
        type: BROADCAST_TAKE_BACKGROUND_LIVE,
        request: async apiClient => {
          // find if a background exists that is created from the template
          let targetBackground = backgrounds.find(
            background => background.source.title === template.title
          );

          // If it does not exist, copy the template and create the background
          // from the generated eventDoc. Find the just-created background
          // from the broadcast
          if (!targetBackground) {
            const payload = {
              type: template.type,
              templateS3Key: template.title
            };

            let eventDoc;

            if (template.isEventTemplate) {
              // is already in event templates
              eventDoc = {
                _id: template._id
              };
            } else {
              // copy template to eventDocs
              eventDoc = await apiClient.broadcast.copyTemplate(
                teamId,
                eventId,
                broadcastId,
                payload
              );
            }

            const { backgrounds } = await apiClient.broadcast.createBackground(
              teamId,
              eventId,
              broadcastId,
              {
                source: {
                  type: IMAGE_FILE,
                  title: template.title,
                  value: eventDoc._id
                },
                layer: {
                  title: FILL_FRAME,
                  style: BackgroundStyles[FILL_FRAME]
                }
              }
            );

            const createdBackground = backgrounds.find(
              background => background.source.value === eventDoc._id
            );

            targetBackground = (
              await mapSignedUrlsToSources(
                [createdBackground],
                apiClient,
                teamId,
                eventId
              )
            )[0];
          }

          // should not update program if selected background is current background
          if (program.style.backgroundId !== targetBackground._id) {
            dispatch(toggleBackgroundHidden(targetBackground._id, true));
          }
        }
      };

      dispatch(action);
    }
  );
}

export default selectBackground;
